<script>
  import { onMount, onDestroy } from 'svelte';

  import { TabContent } from 'carbon-components-svelte';

  import { PERMISSION_TYPE_LABEL_MAP } from '../../../../utils/permission-types';

  import ActiveEntitlements from './ActiveEntitlements.svelte';
  import ExpiredEntitlementsTable from './ExpiredEntitlementsTable.svelte';
  import LoadingSpinner from '../../../../components/LoadingSpinner.svelte';
  import TabsWithRouting from '../../../../components/TabsWithRouting.svelte';

  import { createEntitlementsContext } from '../../../../domains/entitlements/entitlements-controller';

  export let groupId,
    serviceId,
    type,
    groupName = '';

  const permissionId = new URLSearchParams(location.search).get('permissionId');

  const { data, model, controller } = createEntitlementsContext({ groupId, permissionId, serviceId });
  const { loadingAny } = model;

  onMount(() => {
    controller.initialize();
  });
  onDestroy(() => {
    controller.dispose();
  });
</script>

<LoadingSpinner loading={$loadingAny}>
  <h2 class="h4 subpage-heading">{PERMISSION_TYPE_LABEL_MAP[type]}</h2>
  <TabsWithRouting
    param="entitlementsTab"
    defaultParamValue="active"
    tabsWrapperProps={{ fullWidth: true, type: 'container' }}
    tabs={[
      { key: 'active', label: 'Active' },
      { key: 'expired', label: 'Expired' },
    ]}
  >
    <TabContent>
      <ActiveEntitlements {data} {model} {controller} {serviceId} />
    </TabContent>
    <TabContent>
      <ExpiredEntitlementsTable {model} {groupName} permissionName={PERMISSION_TYPE_LABEL_MAP[type]} />
    </TabContent>
  </TabsWithRouting>
</LoadingSpinner>

<style>
  .subpage-heading {
    margin-bottom: 2rem;
  }
</style>
